import React, { useEffect, useState, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useNavigate } from "react-router-dom";
import Badge from "react-bootstrap/Badge";
import jwt_decode from "jwt-decode";
import schoolApi from "../../../api/schoolApi";
import Draggable from "react-draggable";
import "../../../App.css";
import { SessionContext } from "../../SessionProvider";
import Confirm from "../../Confirm"

const Header = ({ allLauncherData, setAllLauncherData }) => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [sessionYear, setSessionYear] = useState([]);
  const { selectedSessionId, setSelectedSessionId } =
    useContext(SessionContext);
  console.log("selectedSessionId@!@=>", selectedSessionId);
  const [sessionModal, setSessionModal] = useState(false);
  //const [reload, setReload] = useState(false);
  const [updateSession, setUpdateSession] = useState(false);

  useEffect(() => {
    async function init() {
      if (!sessionStorage.getItem("token")) navigate("/login");
      try {
        if (sessionStorage.getItem("token")) {
          let user = jwt_decode(sessionStorage.getItem("token"));
          setUserInfo(user);
        }
        const sessions = await schoolApi.fetchSessions();
        console.log("sessionsa=>", sessions);
        if (sessions.success) {
          setSessionYear(sessions.result);
        }
      } catch (error) {}
    }
    init();
  }, []);

  useEffect(() => {
    schoolApi.getAllQuickLauncher().then((result) => {
      if (result?.success) {
        setAllLauncherData(result.records);
      } else {
        setAllLauncherData([]);
      }
    });
  }, []);

  const [sidebar, setSidebar] = useState(false);
  const logout = () => {
    navigate("/login");
    sessionStorage.removeItem("token");
  };

  const toggleSidebar = () => {
    if (sidebar === false) {
      setSidebar(true);
      document.querySelector("#sidebar").classList.toggle("active");
    } else {
      setSidebar(false);
      document.querySelector("#sidebar").classList.toggle("active");
    }
  };

  const [open_Ql, setopen_Ql] = useState(false);
  const QuickLauncher = () => {
    setopen_Ql(!open_Ql);
  };

  // const handleSession = (e) => {
  //   console.log("e.target.value@@+>", e.target.value);
  //   setSelectedSessionId(e.target.value);
  // };


  const handleSession = (e) => {
    setUpdateSession(e.target.value)
    // handleChangeSession();
    setSessionModal(true);
  };

  const ChangeSession = async () => {
    setSelectedSessionId(updateSession);
    setSessionModal(false);
  };

  return (
    <>
    {sessionModal && (
        <Confirm
          show={sessionModal}
          onHide={() => setSessionModal(false)}
          ChangeSession={ChangeSession}
          title="Confirm Change?"
          message="You are going to update the session. Are you sure?"
          table="header_session"
        />
      )}
      <Navbar className="header px-2 mt-1" bg="" expand="lg" variant="">
        <button
          type="button"
          id="sidebarCollapse"
          className="btn btn-primary"
          onClick={toggleSidebar}
        >
          <i className="fa fa-align-left"></i>
        </button>
        <Navbar.Brand href="#home"></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#" className="p-0" style={{ fontSize: ".9rem" }}>
              <img
                src={sessionStorage.getItem("myimage")}
                className="rounded-circle"
                style={{ height: "30px" }}
                alt=""
              />
            </Nav.Link>

            <Nav.Link href="#" className="p-0" style={{ fontSize: ".9rem" }}>
              {}
              <img
                className="rounded-circle"
                id="profileimage"
                style={{ height: "30px" }}
                alt=""
              />
              <Badge style={{ fontSize: ".9rem" }} bg="light" text="dark">
                {userInfo.firstname} {userInfo.lastname}
              </Badge>
              <Badge
                bg="success"
                style={{
                  fontSize: ".9rem",
                  paddingTop: "7px",
                  paddingBottom: "4px",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                }}
              >
                {userInfo.userrole}
              </Badge>
            </Nav.Link>
            <Nav.Link
              href="#"
              className="d-flex p-0"
              style={{ alignItems: "center" }}
            >
              <span className="mx-2" style={{ fontSize: ".9rem" }}>
                School
              </span>{" "}
              <Badge
                style={{
                  fontSize: ".9rem",
                  paddingTop: "7px",
                  paddingBottom: "4px",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                }}
                bg="secondary"
              >
                {userInfo.companyname}
              </Badge>{" "}
            </Nav.Link>
            <Nav.Link
              href="#"
              className="d-flex p-0"
              style={{ alignItems: "center" }}
            >
              <span className="mx-2" style={{ fontSize: ".9rem" }}>
                Session
              </span>{" "}
              <Form.Group className="mx-2">
                <Form.Select
                  name="sessionid"
                  value={selectedSessionId}
                  onChange={handleSession}
                >
                  {sessionYear.map((session) => (
                    <option key={session.id} value={session.id}>
                      {session.year}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Nav.Link>
          </Nav>

          <Nav className="ml-auto">
            <Nav.Link href="/about">
              <i className="fa-solid fa-bell"></i>
            </Nav.Link>
            {sessionStorage.getItem("token") ? (
              <Button variant="btn btn-primary" onClick={logout} title="Logout">
                <i className="fa-solid fa-right-from-bracket"></i>
              </Button>
            ) : (
              <></>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {}
      {allLauncherData.length > 0 && (
        <Draggable
          className="text-dark"
          bounds={{ left: -1300, top: -540, right: 10, bottom: 20 }}
        >
          <div
            style={{
              position: "fixed",
              zIndex: 1000,
              bottom: 20,
              right: 10,
            }}
          >
            <button
              type="button"
              style={{
                position: "fixed",
                background: "#c5597d",
                height: "50px",
                width: "50px",
                borderRadius: "100%",
                border: "1px ",
              }}
              className="btn btn-secondary appLauncher px-2"
              onClick={() => QuickLauncher()}
            >
              <i id="dragIcon" className="fa-solid fa-jet-fighter-up"></i>
            </button>
            {open_Ql && (
              <div className="all_Quick_launcher ">
                {allLauncherData?.map((vl, ky) => (
                  <div className="card  bg-light">
                    <Link
                      className="card-body text-decoration-none"
                      to={vl.sub_module_url}
                      state={{ [vl?.name]: true }}
                      data-toggle="tooltip"
                      data-placement="left"
                      title={vl?.name}
                    >
                      <i className={vl.icon} />
                    </Link>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Draggable>
      )}
    </>
  );
};

export default Header;
